import {React,useEffect, useState} from 'react';
import DatePicker from 'react-datepicker';
import SmartSelect from '@components/form-elements/smartSelect';
import 'react-datepicker/dist/react-datepicker.css';
const FilterOverlay = ({
  filter,
  availableFields,
  overrideFields={},
  onCancel,
  onApply,
  onChange,
  columnMappings = {},
  comparatorOptions={},
  selectedListOptions={},
  dateConditionList={},
  numericOptions={},
  numericTypes=[],
}) => {
  const columnName = filter?.defination;
  const  commonStaticJoined = [
      {
          field: 'assignee',
          fieldtype: 'assignee',
          joinedTable: 'admin',
          select: 'adminID,name',
          check:'name',
          primaryKey: 'adminID',
          slug: ''
      },
      {
          field: 'modified_by',
          fieldtype: 'admin',
          joinedTable: 'admin',
          select: 'adminID,name',
          check:'name',
          primaryKey: 'adminID',
          slug: ''
      },
      {
          field: 'created_by',
          fieldtype: 'admin',
          joinedTable: 'admin',
          select: 'adminID,name',
          check:'name',
          primaryKey: 'adminID',
          slug: ''
      },
      {
          field: 'company_id',
          fieldtype: 'company',
          joinedTable: 'info_settings',
          select: 'infoID,companyName',
          check:'companyName',
          primaryKey: 'infoID',
          slug: ''
      },
      {
          field: 'customer_id',
          fieldtype: 'customer',
          joinedTable: 'customer',
          select: 'customer_id,name',
          check:'name',
          primaryKey: 'customer_id',
          slug: ''
      },
      {
          field: 'default_company',
          fieldtype: 'company',
          joinedTable: 'info_settings',
          select: 'infoID,companyName',
          check:'companyName',
          primaryKey: 'infoID',
          slug: ''
      },
  ];
  //const staticJoin = commonStaticJoined.find(item => item.field === columnName?.Field);
  const staticJoin = commonStaticJoined.find(item =>
    item.field === columnName?.Field || item.field === columnName?.column_name
  );
    const field = availableFields.find(
    f =>
      f.Field === columnName?.Field || // static
      f.column_name === columnName?.Field || // dynamic
      f.column_name === columnName?.column_name // fallback for full object match
  );

  const type = (filter?.defination?.Type ||  filter?.defination?.fieldType || '').toLowerCase();

const isSmartSelect = overrideFields[filter?.defination.Field]?.type === "smartSelectInput";
const isDate = type === 'date' || type === 'datetime' || type === 'date picker';
const isNumeric = numericTypes.includes(type);
const isEnum =
  type.startsWith('enum') ||
  type === 'drop down list' ||
  type === 'dropdown' ||
  type === 'checkbox list' ||
  type === 'radio list' ||
  type === 'smartselectinput' ||
  isSmartSelect;
const conditionList = isDate
  ? dateConditionList
  : isNumeric ? numericOptions: isEnum
    ? selectedListOptions
    : comparatorOptions;

  const getColumnLabel = (colName) => {
    if (columnMappings[colName]) return columnMappings[colName];
    return colName.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  };

const getSmartSelectConfig = (field) => {
  console.log("field Info");
  console.log(field);
      const source = field.linked_with_name;
      return source === 'categories'
        ? {
            valueKey:'pkKey',
            labelKey: `${field.fieldLabel}`,
            type: 'category',
            source: field.linkedDisplayColumn,
            placeholder: `Select ${field.fieldLabel}`,
            allowAddNew: false,
            preload: true,
            cache: true,
            showRecent: true,
            multi: true,
            getLabel: (item) => `${item.categoryName}`,
            getValue: (item) => item.category_id,
          }
        : {
            label: '',
            type: source,
            source,
            valueKey: 'pkKey',
            check: field.linkedDisplayColumn,
            placeholder: `Select ${field.fieldLabel}`,
            allowAddNew: false,
            preload: true,
            cache: true,
            showRecent: true,
            getLabel: (item) => `${item[field.linkedDisplayColumn]}`,
            getValue: (item) => item.pkKey,
            multi: true,
            list: `${field.linkedDisplayColumn},pkKey`,
          };
    };

const renderInput = () => {
  const def = filter?.defination || {};
  const type = (def.Type || def.fieldType || '').toLowerCase();
  const fieldKey = def.Field || def.column_name;
  const fieldLabel = def.fieldLabel || getColumnLabel(fieldKey);
 if (['is_empty', 'is_not_empty'].includes((filter?.condition || '').toLowerCase())) {
    return null;
  }
  const staticJoin = commonStaticJoined.find(item =>
    item.field === def.Field || item.field === def.column_name
  );
  // console.log("def?.fieldOptions");
  //   console.log(filter);
    
  // 🔁 Static joined lookup field (admin, company, etc.)
  const listType = ["drop down list","checkbox list","radio list","radiolist","checkboxlist","dropdown"];
  if(listType.includes(type) && (def.linkedWith !=="" || def.linkedWith !== null)){
    
    if(def?.linkedWith ===null &&  def?.fieldOptions){
      // helper to prettify labels
      const formatLabel = (v) => String(v).replace(/_/g, ' ').replace(/\s+/g, ' ').trim().replace(/\b\w/g, (m) => m.toUpperCase());
      const raw = def?.fieldOptions;
      const enumOptions = Array.isArray(raw) ? raw
      .filter((x) => x !== null && x !== undefined && String(x).trim() !== '')
      .map((o) =>
        typeof o === 'object'
          ? {
              value: o.value ?? o.id ?? o.key ?? String(o.label ?? ''),
              label: o.label ?? formatLabel(o.value ?? o.id ?? o.key ?? ''),
            }
          : { value: String(o), label: formatLabel(o) }
      ) : raw && typeof raw === 'object'
        ? Object.entries(raw).map(([k, v]) => ({
          value: k,
          label: String(v ?? k),
      }))// String: "one, two,three"
      : String(raw || '').split(',').map((s) => s.trim()).filter(Boolean).map((v) => ({ value: v, label: formatLabel(v) }));

      return (
          <div className="flex flex-col gap-1 border rounded p-2 max-h-40 overflow-y-auto">
            {enumOptions.map(({ value, label }) => {
              const isChecked = Array.isArray(filter.value)
                ? filter.value.some(v => v.value === value)
                : false;

              return (
                <label key={value} className="flex items-center gap-2 text-sm">
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => {
                      let updated = Array.isArray(filter.value) ? [...filter.value] : [];

                      if (e.target.checked) {
                        updated.push({ value, label });
                      } else {
                        updated = updated.filter(v => v.value !== value);
                      }

                      onChange('value', updated);
                    }}
                  />
                  {label}
                </label>
              );
            })}
          </div>
        );
    }else{
    return (
      <SmartSelect
        multi={true}
        value={Array.isArray(filter.value) ? filter.value : []}
        onSelect={(selectedOptionsRaw) => {
          const selectedOptions = Array.isArray(selectedOptionsRaw)
            ? selectedOptionsRaw
            : [selectedOptionsRaw];
          onChange('value', selectedOptions);
        }}
        config={getSmartSelectConfig(def)}
      />
    );
  }
  
  }

  // check field in override field with differnt type.
  if(overrideFields && overrideFields[def.Field]){
    const type = overrideFields[def.Field]?.type;
    //const configData = overrideFields[def.Field]?.config;
    const configData = { ...(overrideFields[def.Field]?.config || {}), multi: true,allowAddNew:false };
    if(type === "smartSelectInput"){
      return (
      <SmartSelect
        multi={true}
        value={Array.isArray(filter.value) ? filter.value : []}
        check=''
        onSelect={(selectedOptionsRaw) => {
          const selectedOptions = Array.isArray(selectedOptionsRaw)
            ? selectedOptionsRaw
            : [selectedOptionsRaw];
          onChange('value', selectedOptions);
        }}
        config={configData}
      />
    );
    }
  }
  if (staticJoin) {
    return (
      <SmartSelect
        multi={true}
        value={Array.isArray(filter.value) ? filter.value : []}
        onSelect={(selectedOptionsRaw) => {
          const selectedOptions = Array.isArray(selectedOptionsRaw)
            ? selectedOptionsRaw
            : [selectedOptionsRaw];
          onChange('value', selectedOptions);
        }}
        config={{
          type: staticJoin.fieldtype,
          source: staticJoin.joinedTable,
          list: staticJoin.select,
          check:staticJoin.check,
          valueKey: staticJoin.primaryKey,
          labelKey: staticJoin.select.split(',')[1],
          allowAddNew:false,
          placeholder: `Select ${fieldLabel}`,
          getLabel: (item) => item[staticJoin.select.split(',')[1]],
          getValue: (item) => item[staticJoin.primaryKey],
          multi: true
        }}
      />
    );
  }
   // checkbox list

  // 🔁 Dropdown/dynamic list
  if (type === 'dropdown' || type === 'number') {
    return (
      <SmartSelect
        value={filter.value}
        onSelect={(val) => onChange('value', val)}
        config={{
          type: def.fieldtype || 'category',
          source: def.linkedWith || def.column_name,
          placeholder: `Select ${fieldLabel}`,
          valueKey: 'category_id',
          labelKey: 'categoryName'
        }}
      />
    );
  }

if (type.startsWith("enum(")) {
      const enumRawValues = type.replace(/^enum\((.*)\)$/, '$1').split(',').map(v => v.trim().replace(/^'(.*)'$/, '$1'));

      const enumOptions = enumRawValues.map(val => ({
        value: val,
        label: val.toLowerCase().replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase()),
      }));
        return (
          <div className="flex flex-col gap-1 border rounded p-2 max-h-40 overflow-y-auto">
            {enumOptions.map(({ value, label }) => {
              const isChecked = Array.isArray(filter.value)
                ? filter.value.some(v => v.value === value)
                : false;

              return (
                <label key={value} className="flex items-center gap-2 text-sm">
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => {
                      let updated = Array.isArray(filter.value) ? [...filter.value] : [];

                      if (e.target.checked) {
                        updated.push({ value, label });
                      } else {
                        updated = updated.filter(v => v.value !== value);
                      }

                      onChange('value', updated);
                    }}
                  />
                  {label}
                </label>
              );
            })}
          </div>
        );
      }

 if (type === 'date' || type ==="datetime" || type ==="date picker") {
  const condition = filter.condition;
  const shouldShowSingleDate = condition === 'exact_date';
  const shouldShowRange = condition === 'date_range';

  // 👇 Store selected dates in state or reuse filter.value like this:
  const selectedValue = filter.value || {};

  return (
    <div className="space-y-2">
      {shouldShowSingleDate && (
        <DatePicker
          showMonthDropdown
          showYearDropdown
          selected={selectedValue?.from}
          onChange={(date) => onChange('value', {from:date?.toISOString()})}
          className="ws-date form-input w-full text-gray-600 bg-gray-100 rounded focus:outline-none px-3 py-2 pr-10 px-2 py-1 text-sm"
          placeholderText="Select a date"
          dateFormat="dd-MM-yyyy"
          popperClassName="z-[9999]"
        />
      )}

      {shouldShowRange && (
        <div className="flex gap-2">
          <DatePicker
            selected={selectedValue?.from}
            onChange={(date) => {
              onChange('value', { ...selectedValue, from: date });
            }}
            dateFormat="dd-MM-yyyy"
            className="border px-2 py-1 rounded w-full"
            placeholderText="From date"
            popperClassName="z-[9999]"
          />
          <DatePicker
            selected={selectedValue?.to}
            onChange={(date) => {
              onChange('value', { ...selectedValue, to: date });
            }}
            dateFormat="dd-MM-yyyy"
            className="border px-2 py-1 rounded w-full"
            placeholderText="To date"
            popperClassName="z-[9999]"
          />
        </div>
      )}

      {/* ✅ Other conditions: don't render any input */}
    </div>
  );
}

  // 🔁 Default = Text input
  return (
    <input
      type="text"
      value={ typeof filter.value === 'object' ? filter.value?.[0]?.value : filter.value }
      onChange={(e) => onChange('value', e.target.value)}
      className="border rounded px-2 py-1 w-full"
      placeholder={`Enter ${fieldLabel}`}
    />
  );
};

  return (
    <div className="absolute top-[18px] left-0 bg-white border rounded shadow p-4 z-10 w-80">
      <h4 className="text-sm font-semibold mb-2">{getColumnLabel(columnName?.Field || '')}</h4>

      <select className="border w-full mb-2 px-2 py-1 rounded" value={filter.condition} onChange={(e) => onChange('condition', e.target.value)}>
        {/* {(isDate ? dateConditionList : (staticJoin ? selectedListOptions : comparatorOptions)).map(opt => ( 
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))} */}
        {conditionList.map(opt => (
  <option key={opt.value} value={opt.value}>{opt.label}</option>
))}
      </select>

      <div className="mb-2">{renderInput()}</div>

      <div className="flex justify-end gap-2">
        <button className="text-gray-500 hover:text-red-500 text-sm" onClick={onCancel}> Cancel </button>
       <button
  className="bg-blue-500 hover:bg-blue-600 text-white text-sm px-3 py-1 rounded"
  onClick={() => {
    if (typeof onApply === 'function') {
      onApply({
        ...filter,
        columnName: filter.isDynamic ? filter.defination?.column_name : filter.defination?.Field,
      });
    }
  }}
>
  Apply
</button>


      </div>
    </div>
  );
};

export default FilterOverlay;
